import React from 'react';
import { getShowFiltersHideSearch } from '../../redux/selectors/flyingPage';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterText, setShowFiltersHideSearch } from '../../redux/slice/flyingPage/flyingPage';
import { Button, Tooltip, Icon } from 'antd';

const filterSvg = () => (
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.75 12H6.25C6.11193 12 6 12.1119 6 12.25V13.75C6 13.8881 6.11193 14 6.25 14H11.75C11.8881 14 12 13.8881 12 13.75V12.25C12 12.1119 11.8881 12 11.75 12Z"
      fill="#fff"
    ></path>
    <path
      d="M14.75 6H3.25C3.11193 6 3 6.11193 3 6.25V7.75C3 7.88807 3.11193 8 3.25 8H14.75C14.8881 8 15 7.88807 15 7.75V6.25C15 6.11193 14.8881 6 14.75 6Z"
      fill="#fff"
    ></path>
    <path
      d="M17.75 0H0.25C0.111929 0 0 0.111929 0 0.25V1.75C0 1.88807 0.111929 2 0.25 2H17.75C17.8881 2 18 1.88807 18 1.75V0.25C18 0.111929 17.8881 0 17.75 0Z"
      fill="#fff"
    ></path>
  </svg>
);

const FlightFilterButton: React.FC = () => {
  const dispatch = useDispatch();

  const showFiltersHideSearch = useSelector(getShowFiltersHideSearch);
  const onClickHandler = () => {
    dispatch(setFilterText(undefined));
    dispatch(setShowFiltersHideSearch(!showFiltersHideSearch));
  };
  return (
    <div className="flight-detail-filter-common" style={{ paddingLeft: 0 }}>
      {showFiltersHideSearch ? (
        <Tooltip title="Switch to Search">
          <Button
            className="filter-search-button"
            onClick={onClickHandler}
            type="primary"
            icon="search"
          ></Button>
        </Tooltip>
      ) : (
        <Tooltip title="Switch to Filter">
          <Button className="filter-search-button" onClick={onClickHandler} type="primary">
            <Icon component={filterSvg} />
          </Button>
        </Tooltip>
      )}
    </div>
  );
};

export default FlightFilterButton;
